export default __webpack_public_path__ + "static/media/tal_rapke.53d8edad.jpg";